import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import PageTransition from "./PageTransition";

export default function SiteChrome({ children }) {
  return (
    <div className="min-h-screen bg-sand text-ink font-body" data-testid="site-chrome">
      <Header />
      <PageTransition>{children}</PageTransition>
      <Footer />
    </div>
  );
}
